export default __webpack_public_path__ + "static/media/Illegal.6b9da9aa.png";